<template>
  <div v-if="visibleTasks && visibleTasks.length" class="events w-100">
    <!-- <div class="d-flex align-items-center">
      <div class="title">{{ sectionTitle }}</div>
      <router-link :to="seeAllLink" class="ml-auto see-all-text" v-if="seeAllLink"><b>See all</b></router-link>
    </div> -->

    <div class="d-flex events-list h-100 w-100 mb-2">
      <scroller :scroll-size="450" :threshold="30" class="w-100" :no-gradient-background="true">
        <div class="d-flex" :class="layout">
          <template v-for="(task, index) in visibleTasks" :key="index">
            <event-task-card
              :task="task"
              :open-character-roulette="openCharacterRoulette"
              :open-oc-decoration="openCharacterDecoration"
              :open-art-roulette="openArtRoulette"
              :per-day-sub-count="perDaySubCount"
              @select="getSelectedTask"
              @end="recalcTaskTimes"
            />
          </template>
        </div>
      </scroller>
    </div>

    <router-link v-if="seeAllLink" :to="seeAllLink" class="see-all-text text-primary"
      ><b
        >See all <span v-if="totalCount">{{ totalCount }}</span> current events</b
      ></router-link
    >

    <character-roulette-modal
      :is-open="isCharacterRouletteOpen"
      :close="closeCharacterRoulette"
      @dismiss-modal="closeCharacterRoulette"
    />
    <art-roulette-modal :is-open="isArtRouletteOpen" :close="closeArtRoulette" @dismiss-modal="closeArtRoulette" />
    <choose-char-decoration-modal
      :is-open="isChooseCharDecorationOpen"
      :task="selectedtask"
      :chars="chars"
      :total-chars="totalChars"
      :is-search="isSearchText"
      :loading="loading"
      @search="getSearch"
      @loadMore="loadMore"
      @close="closeCharDecorationModal"
      @dismiss-modal="closeCharDecorationModal"
      @action="closeAndOpenOcModal"
    />
    <oc-decoration-modal :is-open="isOpenDecorateCharModal" :task="selectedtask" @close="closeDecCharModal" />
    <loading-modal :is-open="isOpenLoadingModal" @close="closeLoadingModal" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import { Prop, Watch } from 'vue-property-decorator';
import EventTaskCard from './EventTaskCard.vue';
import { SiteEventTask } from '@/types/static-types';
import { dateHasPassed, formatFromNowInMilliseconds } from '@/utils/dateTime';
import { ListLayout } from '@/types/ui';
import CharacterRouletteModal from '@/modals/CharacterRouletteModal.vue';
import ArtRouletteModal from '@/modals/ArtRouletteModal.vue';
import ChooseCharDecorationModal from '@/modals/ChooseCharDecorationModal.vue';
import LoadingModal from '@/modals/LoadingModal.vue';

import OcDecorationModal from '@/modals/OcDecorationModal.vue';
import {
  fetchDecorCharacters,
  fetchMyOcCharacters,
  fetchSubmissionStatus,
  getAllInPoolChar,
  getCharactersEventPollCounts,
} from '@/actions/events';

@Options({
  name: 'HorizontalEventTasks',
  components: {
    EventTaskCard,
    CharacterRouletteModal,
    ArtRouletteModal,
    ChooseCharDecorationModal,
    OcDecorationModal,
    LoadingModal,
  },
})
export default class HorizontalEventTasks extends Vue {
  get = get;
  isEmpty = isEmpty;
  dateHasPassed = dateHasPassed;
  formatFromNowInMilliseconds = formatFromNowInMilliseconds;
  isCharacterRouletteOpen = false;
  isArtRouletteOpen = false;
  isChooseCharDecorationOpen = false;
  isOpenDecorateCharModal = false;
  ocDecorationOpen = false;
  public selectedtask: any = {};
  public subStatus: any = {};
  public chars = [];
  public isAllCharDisabled = false;
  public loading = true;
  public isSearchText = false;
  public decoration = [];
  public isOcCharsFetching = false;
  public page = 1;
  public totalChars = 0;
  public searchText = '';
  public isOpenLoadingModal = false;
  public perDaySubCount = 0;

  @Prop({ default: () => 'Current Events' }) public sectionTitle!: string;
  @Prop({ required: true }) public quests!: SiteEventTask[];
  @Prop({ required: false }) public seeAllLink!: {};
  @Prop({ default: 0 }) public totalCount!: {};
  @Prop() public layout!: ListLayout;

  public visibleTasks: SiteEventTask[] = [];

  public truncateText(value: string, length = 120) {
    return truncate(value, { length, separator: /,? +/ });
  }

  public recalcTaskTimes(task?: SiteEventTask) {
    if (task && dateHasPassed(task.ends_at) && task.will_refresh)
      setTimeout(() => {
        this.$emit('refresh');
      }, 4000);
    this.visibleTasks = this.quests.filter(
      (q: SiteEventTask) =>
        (!q.ends_at || !dateHasPassed(q.ends_at)) && // ongoing clause 1
        (!q.starts_at || dateHasPassed(q.starts_at))
    ); // ongoing clause 2
    const upcomingTasks = this.quests.filter((q: SiteEventTask) => q.starts_at && !dateHasPassed(q.starts_at));
    this.visibleTasks = [...this.visibleTasks, ...upcomingTasks];
  }

  public getSelectedTask(task: any) {
    this.selectedtask = task;
  }

  public openCharacterRoulette() {
    this.isCharacterRouletteOpen = true;
  }

  public get getDays() {
    const { days } = convertIntoDays(this.selectedtask.ends_at);
    return days;
  }

  public async getSearch(text: any) {
    this.isSearchText = true;

    this.searchText = text;
    const resp = await fetchMyOcCharacters({ ...(!!text && { search: text }), page: 1, page_size: 40 });
    this.chars = resp.results;
    this.totalChars = resp.count;
    this.page = 1;

    this.isSearchText = false;
  }

  public get getHours() {
    const { hours } = convertIntoDays(this.selectedtask.ends_at);
    return hours;
  }

  public async fetchCounts() {
    const resp = await getCharactersEventPollCounts();
    this.perDaySubCount = get(resp, 'total per day submission');
  }

  public async openCharacterDecoration() {
    if (this.getDays >= 1) {
      await this.getOcChars();
    }
    if (!this.isOpenLoadingModal) {
      // this.isChooseCharDecorationOpen = true;

      if (this.isAllCharDisabled) {
        this.isOpenDecorateCharModal = true;
      } else if (this.subStatus.is_submitted && this.getDays >= 1) {
        this.isOpenDecorateCharModal = true;
      } else if (this.getDays < 1 && this.getHours <= 24) {
        this.isOpenDecorateCharModal = true;
      } else if (isEmpty(this.chars)) {
        this.isOpenDecorateCharModal = true;
      } else if (this.subStatus.is_submitted && !isEmpty(this.chars)) {
        this.isOpenDecorateCharModal = true;
      } else this.isChooseCharDecorationOpen = true;
    }
  }

  public closeCharDecorationModal() {
    this.isChooseCharDecorationOpen = false;
    this.getSubStatus();
  }

  public closeAndOpenOcModal() {
    this.closeCharDecorationModal();
    if (!isEmpty(this.decoration)) this.isOpenDecorateCharModal = true;
  }

  public closeDecCharModal() {
    this.isOpenDecorateCharModal = false;
  }

  public closeLoadingModal() {
    this.isOpenLoadingModal = false;
  }

  public async getSubStatus() {
    const resp = await fetchSubmissionStatus();
    this.subStatus = resp;
  }

  public async getOcChars() {
    this.loading = true;
    this.isOcCharsFetching = true;
    this.isOpenLoadingModal = true;
    const resp = await fetchMyOcCharacters({ page: 1, page_size: 40 });
    this.chars = resp.results;
    this.totalChars = resp.count;
    this.loading = false;
    this.closeLoadingModal();
  }

  public async fetchAllInPoolChar() {
    const resp = await getAllInPoolChar();
    this.isAllCharDisabled = resp.all_in_pool;
  }

  public async loadMore() {
    this.page = this.page + 1;
    const resp = await fetchMyOcCharacters({
      page: this.page,
      page_size: 40,
      ...(this.searchText && { search: this.searchText }),
    });
    if (this.page !== 1) {
      this.chars = this.chars.concat(resp.results);
    } else {
      this.chars = resp.results;
    }
    this.totalChars = resp.count;
  }

  public async mounted() {
    await this.fetchAllInPoolChar();
    this.fetchCounts();
    this.getSubStatus();
  }

  public closeCharacterRoulette() {
    this.isCharacterRouletteOpen = false;
  }

  public openArtRoulette() {
    this.isArtRouletteOpen = true;
  }

  public closeArtRoulette() {
    this.isArtRouletteOpen = false;
  }

  @Watch('selectedtask')
  async fetchselectedtask() {
    const resp = await fetchDecorCharacters(this.selectedtask.id);
    this.decoration = resp.results;
  }

  @Watch('quests')
  tasksChanged() {
    if (this.quests && this.quests.length) this.recalcTaskTimes();
    else this.visibleTasks = [];
  }
}
</script>
<style lang="sass" scoped>
.title
  font-size: 36px
  font-weight: bold
  margin-bottom: 12px
  margin-top: 30px
.finish-msg
  font-size: 18px
  font-weight: bold
.events
  overflow-x: auto
.events-list
  overflow-x: auto
.events-list::-webkit-scrollbar
  display: none
.events-list
  -ms-overflow-style: none
  scrollbar-width: none
.actions
  position: absolute
  bottom: 0
.see-all-text
  margin-top: 1rem
  font-size: 16px
  color: #214163
  text-decoration: underline
.mb-5
  color: #737373
</style>
